export const formatDisplayUrl = (url) => {
  return url.replace("https://", "").replace("http://", "").replace("www.", "");
};

export default { formatDisplayUrl };
